import http from './http'
import { environment } from '@mortgage-pos/ui/env'

export async function getRedirectToken(accessToken: string) {
  const response = await http.post(
    `${environment.apiBaseUrl}/api/robinhood/redirect-token`,
    {
      access_token: accessToken,
    }
  )

  return response?.data?.redirect_token as string
}
